import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsTabComponent } from '../../../../../../../@shared/components/innform-question-sidepanel/tabs/comments/comments-tab.component';
import { COMMENTS_TYPE } from '../../../../../../../@core/models/enums';

/**
 * Comments tab wrapper component
 * Wraps the shared comments component for use in comparison tabs
 */
@Component({
    selector: 'app-compare-comments-tab-wrapper',
    standalone: true,
    imports: [CommonModule, CommentsTabComponent],
    template: `
        <app-comments-tab 
            [itemId]="comparisonId" 
            [commentsType]="commentsType">
        </app-comments-tab>
    `
})
export class CompareCommentsTabWrapperComponent {
    @Input() comparisonId: string = '';
    @Input() commentsType: COMMENTS_TYPE = COMMENTS_TYPE.COMPARISON;
}

